import React from 'react';
import Section from '../../components/ui/Section';
import { motion } from 'framer-motion';

const Datenschutz = () => (
  <div className="pt-32">
    <Section className="bg-dark">
      <div className="max-w-3xl mx-auto">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-gold tracking-widest uppercase text-sm mb-4">Legal</motion.p>
        <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-5xl font-serif text-cream mb-12">Datenschutzerklärung</motion.h1>
        <div className="space-y-8 text-cream/65 font-light text-lg leading-relaxed">
          {[
            { title: '1. Datenschutz auf einen Blick', body: 'Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.' },
            { title: '2. Datenerfassung auf dieser Website', body: 'Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.' },
            { title: '3. Ihre Rechte', body: 'Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.' },
            { title: '4. Analyse-Tools und Tools von Drittanbietern', body: 'Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit sogenannten Analyseprogrammen. Detaillierte Informationen zu diesen Analyseprogrammen finden Sie in der folgenden Datenschutzerklärung.' },
          ].map((item, i) => (
            <div key={i}>
              <h2 className="text-xl font-serif text-cream mb-3">{item.title}</h2>
              <p>{item.body}</p>
            </div>
          ))}
        </div>
      </div>
    </Section>
  </div>
);

export default Datenschutz;